import type { DocumentSearchMode } from 'features/knowledgeDocumentViewer/types'
import { DocumentsViewerContentFilter } from 'routes/documents/-searchParams'

import type { SearchEngine } from './documentSearchApiSchemas'

export function isAiDocumentSearchEngine(
  engine: SearchEngine
): engine is Exclude<SearchEngine, 'unified'> {
  return engine === 'agentic' || engine === 'documentChat'
}

export function getDocumentSearchEngine({
  searchMode,
  contentFilter,
  isLinkedDocsMode,
  browseAll,
  hasDocChatViewer,
}: {
  searchMode: DocumentSearchMode
  contentFilter: DocumentsViewerContentFilter
  isLinkedDocsMode: boolean
  browseAll: boolean
  hasDocChatViewer: boolean
}): SearchEngine {
  if (
    searchMode === 'agentic' &&
    contentFilter === 'documents' &&
    !isLinkedDocsMode &&
    !browseAll
  ) {
    return hasDocChatViewer ? 'documentChat' : 'agentic'
  }
  return 'unified'
}
